<template>
  <vx-card id="loader2">
    <vs-row class="text-xl p-2 pt-20" vs-type="flex" vs-justify="center">
      <vs-col class="p-10" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">

        <vs-button @click="updateStatus('Complete')" color="green" size="large" class="m-5 text-black font-bold"
          style="height: 100px;">Complete</vs-button>
        <vs-button @click="updateStatus('Quarantine')" color="Orange" size="large" class="m-5 text-black font-bold"
          style="height: 100px;">Quarantine</vs-button>

      </vs-col>
    </vs-row>

    <vs-row class="text-xl p-2 pt-20" vs-type="flex" vs-justify="center">
      <vs-col class="p-10" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button @click="cancel()" color="warning" size="large">Close</vs-button>
      </vs-col>
    </vs-row>

  </vx-card>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { helperMixin } from '@/mixin/helperMixin'
import { dialogMixin } from '@/mixin/dialogMixin'
import { axiosMixin } from '@/mixin/axiosMixin'
import { alertMixin } from '@/mixin/alertMixin'

import axios from '@/axios.js'
export default {
  mixins: [helperMixin, dialogMixin, axiosMixin, alertMixin],
  components: {
    vSelect
  },
  props: {
    rowId: {
      type: String | Number,
      default: ''
    },
  },
  data() {
    return {
      reasonModel: '',
      showRejectReason: false,
      showAlert: false,
      showRejectReason: false,
      rejectReasonMessage: '',
      reasonModel: '',
      payLoad: {},
      endPoint: '',
      rejectDialogTitle: '',
      successMessage: '',
      sucessEventName: '',
      successEventValue: ''
    }
  },

  computed: {
    ...mapGetters({
      getCurrentDataStructureInChunkForView:
        'profile/getCurrentDataStructureInChunkForView',
      getOrigCurrentDataStructure: 'profile/getOrigCurrentDataStructure',
      getMainInfo: 'profile/getCurrentMainInfo',
      getUserInfo: 'auth/getUserInfo',
      getProjectSelected: 'auth/getProjectSelected'
    }),

    settings() {
      this.showAlert = true //we need to trigger this so that the alert will show

      return this.getMainInfoSettings(
        this.$route.params.subject,
        this.$route.params.key
      )
    },
    baseURl() {
      return axios.defaults.baseURL
    }
  },
  created() { },
  mounted() {
    console.log('getUserInfo:::', this.getUserInfo)
  },

  methods: {
    startLoading() {
      this.$vs.loading({
        container: '#loader2',
        scale: 0.6
      })
    },
    closeLoading() {
      this.$vs.loading.close('#loader2 > .con-vs-loading')
    },
    updateStatus(status) {
      this.startLoading('loader2')
      this.aronPost(
        'updateGrStatus',
        { status: status, id: this.rowId },
        '',
        ''
      )
        .then(response => {
          this.closeLoading('loader2')
          if (response.data.code == 200) {
            this.successAlert('Success', 'GR has been updated')
            this.$emit('refreshTable', { status: status })
          } else {
            this.errorAlert('Warning', response.data.error)
          }

          this.closeLoading('loader2')
        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
          this.closeLoading('loader2')
        })
    },
    validateRejectRecord() {
      if (this.reasonModel == '') {
        this.errorAlert('Required', 'The Reason field is required')
        this.showRejectReason = true
      } else {
        this.showRejectReason = false
        this.rejectTheRecordNow()
      }
    },
    cancel() {
      this.$emit('result', 'test')
    },
    approveNow() {
      this.confirmAlert(
        'Approve Record',
        'Are you sure you want to Approve this record?'
      ).then(val => {
        this.aronPost(
          'approvedRecord',
          { agencyRecordID: this.getMainInfo.id },
          '',
          ''
        )
          .then(response => {
            if (response.data.code == 200) {
              this.successAlert('Success', 'Rekod telah berjaya disimpan')
              this.$emit('result', 'list')
            } else {
              this.errorAlert('Warning', response.data.error)
            }

            this.stopLoading('loader')
          })
          .catch(error => {
            // this.decodeErrorFromAxios(error);
            this.stopLoading('loader')
          })
      })
    },
    rejectRecord() {
      this.showRejectReason = true
    },
    rejectTheRecordNow() {
      var thisOrig = this
      this.aronPost(
        'rejectRecord',
        { agencyRecordID: this.getMainInfo.id, reason: this.reasonModel },
        '',
        ''
      )
        .then(response => {
          if (response.data.code == 200) {
            this.successAlert('Success', 'Rekod telah berjaya disimpan')
            this.$emit('result', 'list')
          } else {
            this.errorAlert('Warning', response.data.error)
          }
        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
        })
    },
    handleEmitEvent(eventName, eventValue) {
      this.$emit(eventName, { eventName: eventName, eventValue: eventValue })
    },
    handleSubmit(
      endPoint,
      title,
      message,
      payLoad,
      getReason,
      rejectReasonMessage,
      rejectDialogTitle,
      successMessage,
      sucessEventName,
      successEventValue
    ) {
      this.payLoad = payLoad
      this.endPoint = endPoint
      this.successMessage = successMessage
      if (getReason) {
        this.showRejectReason = true
        this.rejectReasonMessage = rejectReasonMessage
        this.rejectDialogTitle = rejectDialogTitle
      } else {
        this.confirmAlert(title, message).then(res => {
          this.submitNow()
        })
      }
    },
    validateReason() {
      if (this.reasonModel == '') {
        this.errorAlert('Required', 'The Reason field is required')
        this.showRejectReason = true
      } else {
        this.addToObject(this.payLoad, { rejectReason: this.reasonModel })
        this.submitNow()
      }
    },
    submitNow() {
      this.aronPost(this.endPoint, this.payLoad, '', '')
        .then(response => {
          if (response.data.status == 'success') {
            this.normarAlert('Success', this.successMessage).then(res => {
              this.$emit(this.sucessEventName, {
                eventName: this.sucessEventName,
                eventValue: this.successEventValue
              })
            })
          } else {
            this.normarAlert(
              'Error',
              'Something Went wrong please try again later'
            ).then(res => {
              this.$emit(this.sucessEventName, {
                eventName: this.sucessEventName,
                eventValue: this.successEventValue
              })
            })
          }

          //go back
        })
        .catch(error => {
          console.error('error ActionContainer reason:', error)
        })
    },
    showFileOrImageHandler(source) {
      var filename = this.getFileExtention(source)
      if (filename == 'pdf') {
        this.showPdf = true
        this.thePdfSource = this.baseURl + '/storage/' + source
      } else if (
        filename == 'jpeg' ||
        filename == 'jpg' ||
        filename == 'png' ||
        filename == 'gif'
      ) {
        this.showImage = true
        return this.baseURl + '/storage/' + source
      }
    },
    editData() { },
    formatCurrency(currency, value) {
      return this.displayCurrency(currency, value)
    },
    decodeSelectValue(value, options) {
      return this.decodeValueForSelect(options, value)
    },
    decodeMultiSelectValue(value) {
      return this.flattenJsonStringArray(value, 'label')
    }
  }
}
</script>
